import * as Sentry from "@sentry/react";

export function logProjectEvent(projectId: string, event: string, data: any) {
  Sentry.logger.info(`project-${projectId}-${event}-${Date.now()}`, data);
}

export function logException(error: any, data: any) {
  console.error(error, data);
  Sentry.captureException(error, {
    extra: data,
  });
}
